import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Util from 'lib/util';

import {
  Button,
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import CropFreeIcon from '@material-ui/icons/CropFree';
import CommonFns from 'functions/common.ts';

function SaleDeliveryReturnList(props) {
  const Config = {
    sale: {
      apiPath: '/customerReturnOrder/list',
      orderProperty: 'createTime',
      //枚举列表
      arrEnumField: [
        { mainKey: 'B02_Rto_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Boolean_Result',
          subKey: 'isExchangeProd',
          value: 'isExchangeProdName'
        }
      ],
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/delivery/return/detail',
      searchBarPlaceholder: '客户名称/编码、退货单号、产品名称/编码/规格',
      tabs: ['客户验退', '客户仓退'],
      tabConfig: [
        1, //客户验退
        2 //客户仓退
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    decimalPlace,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      returnType: config.tabConfig[currentTab]
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.rtoXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>序号{index + 1}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('rto', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>{item.customerName}</div>
                          </li>
                        )}
                        <li>
                          <label>退货单号</label>
                          <div>{item.rtoErpNo}</div>
                        </li>
                        <li>
                          <label>退货日期</label>
                          <div>
                            {formatDate(item.erpReturnDate, 'YYYY-MM-DD')}
                          </div>
                        </li>
                        <li>
                          <label>是否换货</label>
                          <div>{item.isExchangeProdName}</div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

SaleDeliveryReturnList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(SaleDeliveryReturnList);
